import * as tslib_1 from "tslib";
import React, { Component } from 'react';
import { noop, omit } from 'lodash';
import PropTypes from 'prop-types';
import Label from '../Label';

var LabeledCheckable =
/** @class */
function (_super) {
  tslib_1.__extends(LabeledCheckable, _super);

  function LabeledCheckable() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.handleLabelClick = function () {
      var _a = _this.props,
          checked = _a.checked,
          disabled = _a.disabled,
          onChange = _a.onChange;
      if (disabled) return;
      onChange(!checked);
    };

    return _this;
  }

  LabeledCheckable.prototype.render = function () {
    var _a = this.props,
        label = _a.label,
        size = _a.size,
        containerHeight = _a.containerHeight,
        checked = _a.checked,
        disabled = _a.disabled,
        containerClassName = _a.containerClassName,
        labelClassName = _a.labelClassName,
        multiline = _a.multiline,
        Component = _a.component,
        other = tslib_1.__rest(_a, ["label", "size", "containerHeight", "checked", "disabled", "containerClassName", "labelClassName", "multiline", "component"]);

    var finalContainerHeight = typeof containerHeight === 'undefined' ? size : containerHeight;
    return React.createElement(Label, {
      containerHeight: finalContainerHeight,
      text: label,
      align: "control",
      kind: checked ? 'checked' : null,
      disabled: disabled,
      containerClassName: containerClassName,
      labelClassName: labelClassName,
      onClick: this.handleLabelClick,
      multiline: multiline
    }, React.createElement(Component, tslib_1.__assign({}, other, {
      size: size,
      checked: checked,
      disabled: disabled
    })));
  };

  LabeledCheckable.propTypes = tslib_1.__assign({}, omit(Label.propTypes, ['text', 'align']), {
    label: PropTypes.node,
    onChange: PropTypes.func,
    checked: PropTypes.bool,
    size: PropTypes.number,
    component: PropTypes.func.isRequired
  });
  LabeledCheckable.defaultProps = {
    onChange: noop
  };
  return LabeledCheckable;
}(Component);

export default LabeledCheckable;

try {
  // @ts-ignore
  LabeledCheckable.__docgenInfo = {
    "description": "",
    "displayName": "LabeledCheckable",
    "props": {}
  };
} catch (__react_docgen_typescript_loader_error) {}